import axios from "./axios";

export async function fetchPublicProjects(params = {}) {
  return axios({
    method: "get",
    url: "/projects/public",
    params: params,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || { error: "Failed to fetch projects" };
    });
}

export async function fetchPublicProject(id) {
  return axios({
    method: "get",
    url: `/projects/${id}/public`,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || { error: "Failed to fetch project" };
    });
}

